import { render, staticRenderFns } from "./Auditory.vue?vue&type=template&id=3a3ccb6b&"
import script from "./Auditory.vue?vue&type=script&lang=js&"
export * from "./Auditory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Auditory.vue"
export default component.exports